import { c as _c } from "react-compiler-runtime";
import styled from 'foundations-theming/utils';
import { fwcColor } from 'foundations-theming/utils/fwc';
import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';

/**
 * A single segment of the floating cell-selection action menu.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Pill = styled.div.withConfig({
  displayName: "CellActionMenu__Pill"
})(["display:inline-flex;align-items:stretch;overflow:hidden;border-radius:", ";background-color:", ";color:", ";box-shadow:", ";"], ({
  theme
}) => theme.borderRadius.full, ({
  theme
}) => theme.color[fwcColor('fwc-button-fill-primary-default')], ({
  theme
}) => theme.color[fwcColor('fwc-button-text-primary-default')], ({
  theme
}) => theme.boxShadow['300']);
const Content = styled.span.withConfig({
  displayName: "CellActionMenu__Content"
})(["display:inline-flex;align-items:center;"]);
const Segment = styled.button.withConfig({
  displayName: "CellActionMenu__Segment"
})(["display:inline-flex;align-items:center;margin:0;border:0;background:transparent;color:inherit;cursor:pointer;padding-block:", ";padding-inline:", ";font-size:", ";transition:background-color 0.1s ease-in-out;&:hover{background-color:", ";}&:active{background-color:", ";}&:focus-visible{outline:", " solid ", ";outline-offset:-4px;}"], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.space['300'], ({
  theme
}) => theme.typography['detail-100'].fontSize, ({
  theme
}) => theme.color[fwcColor('fwc-button-fill-primary-hover')], ({
  theme
}) => theme.color[fwcColor('fwc-button-fill-primary-pressed')], ({
  theme
}) => theme.borderWidth['200'], ({
  theme
}) => theme.color[fwcColor('fwc-button-text-primary-default')]);

/**
 * The floating action menu shown next to the active selection's fill handle. It
 * renders as a Trellis-"primary" split button: a single rounded pill divided
 * into per-action segments (icon + label).
 *
 * Trellis has no split-button / button-group component yet (the alpha one isn't
 * cleared for use), so this is a hand-styled stand-in built from primary-button
 * tokens. The `items` prop is intentionally shaped like a button group so a real
 * Trellis component can replace this internals-only file later without changing
 * callers.
 */
export const CellActionMenu = t0 => {
  const $ = _c(5);
  const {
    ariaLabel,
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ariaLabel || $[3] !== t1) {
    t2 = /*#__PURE__*/_jsx(Pill, {
      role: "group",
      "aria-label": ariaLabel,
      "data-test-id": "cell-action-menu",
      children: t1
    });
    $[2] = ariaLabel;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
function _temp(t0) {
  const {
    key,
    label,
    Icon,
    shortcut,
    onClick
  } = t0;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: shortcut ? /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "50",
      children: [label, /*#__PURE__*/_jsx(Small, {
        tagName: "kbd",
        typography: "detail-100",
        children: shortcut
      })]
    }) : label,
    children: /*#__PURE__*/_jsx(Segment, {
      type: "button",
      "aria-label": label,
      "data-test-id": `cell-action-menu-${key}`,
      onClick: e => {
        onClick();
        if (e.detail > 0) {
          e.currentTarget.blur();
        }
      },
      children: /*#__PURE__*/_jsx(Content, {
        children: /*#__PURE__*/_jsx(Icon, {})
      })
    })
  }, key);
}